module.exports = __webpack_public_path__ + "static/media/ic_close_dialog.a80fb2be.svg";